import { RxConversationAPI, RxLiveAPI } from '@driftt/dapper'
import { Observable } from 'rxjs'
import { ConversationAPIAuthEnabled } from 'app/auth-requests/api'

export const API = {
  sendWelcomeMessage(data) {
    return RxConversationAPI
      .post(`/ws/messages?ws_user_id=${data.presenceEndUserId}`, data.payload)
      .map(({ response }) => response)
  },

  bootstrapUser(anonID) {
    const payload = {
      topic: 'widget:bootstrapEndUser',
      anonId: anonID
    }

    return RxConversationAPI
      .post('/ws/messages', payload)
      .map(({ response }) => response)
  },

  sendActiveStatus(conversationId) {
    const queryString = conversationId ? `?conversationId=${conversationId}` : ''
    return Observable.fromPromise(
      ConversationAPIAuthEnabled
      .post(`/agents/active${queryString}`)
      .then(res => res.response))
  },


  getPresenceState(query = { size:25 }) {
    return RxLiveAPI
      .post("/visitor/searchWithCounts", query)
      .map(({ response }) => response)
  }


}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/presence/api.js